import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  IconButton,
  InputAdornment,
  Card,
  Autocomplete,
  Stack,
  Button,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Close as CloseIcon, Search, Refresh } from '@mui/icons-material';
import { KeyboardArrowDown } from '@mui/icons-material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import HeaderHelpPage from '../../../components/HeaderHelpPage';
import { sendDataWithPost, sendDataWithGet } from '../../../services/services';
import { showSuccessMsg, showErrorMsg } from '../../../utils/toast';
import moment from 'moment';
import { StorageUtils } from '../../../utils/index';
import { APP_USER_SESSION } from '../../../constant/AppConstants';
import { COLORS } from '../../../utils/colors';
import CircularLoader from '../../../components/circularLoader';
import { PAYMENT_HOST_LIST, SOURCE } from '../../../utils/constants';
import ButtonCustom from '../../../components/ButtonCustom';
import { styles } from '../../../utils/styles';
import ShowDetail from '../../../components/ShowDetail';

const ACQUIRER_BRANDS_MAPPING = {
  [PAYMENT_HOST_LIST.PAYNOW]: [
    { label: `SCB_PayNow (${SOURCE.GW2})`, value: 'SCB_PayNow' },
    { label: `Paynow (${SOURCE.GW3})`, value: 'Paynow' },
  ],
  [PAYMENT_HOST_LIST.ATOME]: [
    { label: `Atome (${SOURCE.GW2} and ${SOURCE.GW3})`, value: 'Atome' }
  ],
  [PAYMENT_HOST_LIST.ALIPAY]: [
    { label: `alipayHost (${SOURCE.GW2})`, value: 'alipayHost' },
    { label: `Alipay (${SOURCE.GW3})`, value: 'AliPay' },
  ],
  [PAYMENT_HOST_LIST.WECHAT]: [
    { label: `wechatHost (${SOURCE.GW2})`, value: 'wechatHost' },
    { label: `Wechat (${SOURCE.GW3})`, value: 'WeChat' },
  ],
  [PAYMENT_HOST_LIST.GRABPAY]: [
    { label: `GrabPay (${SOURCE.GW2} and ${SOURCE.GW3})`, value: 'GrabPay' },
    { label: `GrabpayV3 (${SOURCE.GW2})`, value: 'GrabpayV3' },
  ],
  [PAYMENT_HOST_LIST.SHOPEE]: [
    { label: `ShopeePay (${SOURCE.GW2})`, value: 'ShopeePay' },
    { label: `Shopeepay (${SOURCE.GW3})`, value: 'Shopeepay' },
  ],
  [PAYMENT_HOST_LIST.DASH]: [
    { label: `Dash (${SOURCE.GW2} and ${SOURCE.GW3})`, value: 'Dash' }
  ],
  [PAYMENT_HOST_LIST.DCI]: [
    { label: `Diners (${SOURCE.GW2} and ${SOURCE.GW3})`, value: 'Diners' },
    { label: `Discover (${SOURCE.GW2} and ${SOURCE.GW3})`, value: 'Discover' },
  ],
  [PAYMENT_HOST_LIST.GP]: [
    { label: `Visa (${SOURCE.GW2})`, value: 'Visa' },
    { label: `MasterCard (${SOURCE.GW2})`, value: 'MasterCard' },
  ],
  [PAYMENT_HOST_LIST.FIUU]: [
    { label: `Visa (${SOURCE.GW3})`, value: 'Visa' },
    { label: `Mastercard (${SOURCE.GW3})`, value: 'Mastercard' },
  ],
  [PAYMENT_HOST_LIST.LIQUIDNET]: [
    { label: `Paynow (${SOURCE.GW3})`, value: 'Paynow' },
    { label: `UPI (${SOURCE.GW3})`, value: 'UPI' },
  ],
  [PAYMENT_HOST_LIST.FOMOPAY]: [
    { label: `PayNow (${SOURCE.GW3})`, value: 'PayNow' },
  ],
  [PAYMENT_HOST_LIST.ALLINPAY]: [
    { label: `Amex (${SOURCE.GW3})`, value: 'Amex' },
    { label: `UnionPay (${SOURCE.GW3})`, value: 'UnionPay' },
    { label: `Visa (${SOURCE.GW3})`, value: 'Visa' },
    { label: `MasterCard (${SOURCE.GW3})`, value: 'MasterCard' },
  ],
};

const getBrandLabelFromMapping = (brand, acquirer) => {
  if (!brand || !acquirer) return brand || '';
  const list = ACQUIRER_BRANDS_MAPPING[acquirer.toLowerCase()] || [];
  const found = list.find((item) => item.value === brand);
  return found ? found.label : brand;
};

const CURRENCY_OPTIONS = ['SGD', 'USD', 'JPY', 'MYR', 'EUR', 'THB'];

const formatAcquirer = (acquirer) => {
  if (!acquirer || acquirer === 'N/A') return 'N/A';
  return acquirer.charAt(0).toUpperCase() + acquirer.slice(1).toLowerCase();
};

const Adjustment = () => {
  const [adjustments, setAdjustments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [createDate, setCreateDate] = useState(null);
  const [payoutDate, setPayoutDate] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [currentUserName, setCurrentUserName] = useState('');
  
  const userRole = StorageUtils.getParsedValue(APP_USER_SESSION).role;
  const adjustmentRole = userRole.adjustment || [];
  
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);
  const [checkLoading, setCheckLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  
  const [openDetailDialog, setOpenDetailDialog] = useState(false);
  const [selectedAdjustment, setSelectedAdjustment] = useState(null);
  
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [merchants, setMerchants] = useState([]);
  const [loadingMerchants, setLoadingMerchants] = useState(false);
  const [brands, setBrands] = useState([]);
  const [loadingBrands, setLoadingBrands] = useState(false);
  const [acquirers, setAcquirers] = useState([]);
  const [defaultTxnFee, setDefaultTxnFee] = useState(0);
  const [loadingTxnFee, setLoadingTxnFee] = useState(false);

  const [formData, setFormData] = useState({
    merchant_name: '',
    merchant_id: '',
    bank_account_no: '',
    type: '',
    brand: '',
    currency: '',
    acquirer: '',
    txn_amount: '',
    txn_fee: '',
    total_amount: '',
    details: ''
  });
  const [txnAmountSign, setTxnAmountSign] = useState('+');
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    if (adjustmentRole.includes("View")) {
      loadAdjustments();
    }
  }, []);

  const loadFilterConditions = async () => {
    setLoadingMerchants(true);
    
    const handleSuccess = () => {
      setLoadingMerchants(false);
    };

    const handleError = () => {
      console.error('Failed to load filter conditions');
      showErrorMsg('Failed to load filter conditions');
      setLoadingMerchants(false);
      setMerchants([]);
    };

    const setFilterData = (data) => {
      if (data?.merchants) {
        setMerchants(data.merchants);
      }
    };

    sendDataWithGet(
      '/payout/adjustment/adjustment_filter_conditions/',
      setFilterData,
      null,
      handleSuccess,
      handleError
    );
  };

  const loadAdjustments = async () => {
    setLoading(true);
    
    const handleSuccess = (response) => {
      if (response.data?.results) {
        if (response.data.current_user_name) {
          setCurrentUserName(response.data.current_user_name);
        }
        
        // Transform data to match UI format
        const transformedData = response.data.results.map((item, index) => {
          const transformed = {
            id: item.id || index,
            created_date: item.created_date || item.date_time_created,
            merchant_name: item.merchant?.merchant_name || 'Unknown Merchant',
            merchant_id: item.merchant_id || '',
            type: item.type || determineAdjustmentType(item.adjustment_amount),
            brand: item.payment_host?.name || 'N/A',
            acquirer: item.acquirer || 'N/A',
            currency: item.currency || 'SGD',
            txn_amount: parseFloat(item.transaction_amount || item.adjustment_amount || 0),
            txn_fee: parseFloat(item.transaction_fee || 0),
            total_amount: parseFloat(item.adjustment_amount || 0),
            message: item.message || '',
            payout_status: item.payout_status,
            account_number: item.account_number,
            created_by: item.created_by,
            approved_by: item.approved_by,
            approved_at: item.approved_at,
            payout_date: item.payout_date
          };
          
          
          return transformed;
        });
        setAdjustments(transformedData);
      } else {
        setAdjustments([]);
      }
      setLoading(false);
    };

    const handleError = (error) => {
      console.error('Failed to load adjustments:', error);
      showErrorMsg('Failed to load adjustments');
      setLoading(false);
    };

    const filters = { status: selectedStatus };
    if (createDate && moment(createDate).isValid()) {
      filters.create_date = moment(createDate).format('YYYY-MM-DD');
    }
    if (payoutDate && moment(payoutDate).isValid()) {
      filters.payout_date = moment(payoutDate).format('YYYY-MM-DD');
    }

    sendDataWithPost(
      '/payout/adjustment/adjustment_list/',
      filters,
      null,
      null,
      handleSuccess,
      handleError
    );
  };

  const determineAdjustmentType = (amount) => {
    const value = parseFloat(amount || 0);
    if (value < 0) return 'Chargeback';
    if (value > 0) return 'Refund';
    return 'Adjustment';
  };

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleSearch = () => {
    setPage(0);
    if (adjustmentRole.includes("View")) {
      loadAdjustments();
    }
  };

  const handleReset = () => {
    setSelectedStatus('all');
    setCreateDate(null);
    setPayoutDate(null);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleCreateAdjustment = () => {
    setFormData({
      merchant_name: '',
      merchant_id: '',
      bank_account_no: '',
      type: '',
      brand: '',
      currency: '',
      acquirer: '',
      txn_amount: '',
      txn_fee: '',
      total_amount: '',
      details: ''
    });
    setTxnAmountSign('+');
    setBrands([]);
    setAcquirers([]);
    setDefaultTxnFee(0);
    setFormSubmitted(false);
    setOpenCreateDialog(true);
    if (merchants.length === 0) {
      loadFilterConditions();
    }
  };

  const loadAcquirersForMerchant = async (merchantId, merchantName, currentAcquirerValue = null) => {
    if (!merchantId) {
      setAcquirers([]);
      return;
    }
    
    const currentAcquirer = currentAcquirerValue || formData.acquirer;
    
    setLoadingBrands(true);
    try {
      const response = await sendDataWithPost(
        '/payout/adjustment/adjustment_filter_conditions/',
        { merchant_id: merchantId, merchant_name: merchantName }
      );
      
      // Load acquirers for this merchant
      let acquirersData = null;
      if (response.data && response.data.acquirers) {
        acquirersData = response.data.acquirers;
      } else if (response.acquirers) {
        acquirersData = response.acquirers;
      }
      
      if (acquirersData) {
        const mergedAcquirers = [...new Set([...acquirersData, ...(currentAcquirer ? [currentAcquirer] : [])])];
        setAcquirers(mergedAcquirers);
      } else {
        setAcquirers(currentAcquirer ? [currentAcquirer] : []);
      }
    } catch (error) {
      console.error('Failed to load acquirers:', error);
      setAcquirers(currentAcquirer ? [currentAcquirer] : []);
    } finally {
      setLoadingBrands(false);
    }
  };

  const loadBrandsForAcquirer = (acquirer) => {
    if (!acquirer) {
      setBrands([]);
      return;
    }
    
    // Get brands from mapping
    const brandsForAcquirer = ACQUIRER_BRANDS_MAPPING[acquirer.toLowerCase()] || [];
    setBrands(brandsForAcquirer);
  };


  const loadTxnFeeForMerchantAndAcquirer = async (merchantId, acquirer) => {
    if (!merchantId || !acquirer) {
      setDefaultTxnFee(0);
      return;
    }
    
    setLoadingTxnFee(true);
    try {
      const selectedMerchant = merchants.find(m => m.id === merchantId);
      const response = await sendDataWithPost(
        '/payout/adjustment/adjustment_filter_conditions/',
        { 
          merchant_id: merchantId, 
          merchant_name: selectedMerchant ? selectedMerchant.name : '',
          acquirer: acquirer 
        }
      );
      
      let txnFeeData = null;
      if (response.data && response.data.txn_fee !== undefined) {
        txnFeeData = response.data.txn_fee;
      } else if (response.txn_fee !== undefined) {
        txnFeeData = response.txn_fee;
      }
      
      if (txnFeeData !== null && txnFeeData !== undefined) {
        setDefaultTxnFee(txnFeeData);
        
        setFormData(prev => {
          const updated = { ...prev, txn_fee: txnFeeData.toString() };
          
          const rawAmount = parseFloat(prev.txn_amount) || 0;
          const rawFee = Math.abs(parseFloat(txnFeeData) || 0);
          const type = prev.type || '';
          if (['Refund', 'Chargeback'].includes(type)) {
            updated.total_amount = (-Math.abs(rawAmount) + rawFee).toFixed(3);
          } else {
            const signMultiplier = txnAmountSign === '-' ? -1 : 1;
            const signedAmount = signMultiplier * Math.abs(rawAmount);
            updated.total_amount = (signedAmount + (signMultiplier === -1 ? rawFee : -rawFee)).toFixed(3);
          }
          
          return updated;
        });
      } else {
        setDefaultTxnFee(0);
      }
    } catch (error) {
      console.error('Failed to load txn_fee:', error);
      setDefaultTxnFee(0);
    } finally {
      setLoadingTxnFee(false);
    }
  };

  const handleCloseCreateDialog = () => {
    setOpenCreateDialog(false);
          setFormData({
            merchant_name: '',
            merchant_id: '',
            bank_account_no: '',
            type: '',
            brand: '',
            currency: '',
            acquirer: '',
            txn_amount: '',
            txn_fee: '',
            total_amount: '',
            details: ''
            });
      setTxnAmountSign('+');
      setBrands([]);
      setAcquirers([]);
      setDefaultTxnFee(0);
      setFormSubmitted(false);
    };

  const handleFormChange = (field, value) => {
    setFormData(prev => {
      const updated = { ...prev, [field]: value };
      
      if (field === 'merchant_name') {
        const selectedMerchant = merchants.find(m => m.id === value);
        if (selectedMerchant) {
          updated.merchant_id = selectedMerchant.id;
          updated.bank_account_no = selectedMerchant.account || '';
          
          loadAcquirersForMerchant(selectedMerchant.id, selectedMerchant.name);
        } else {
          updated.bank_account_no = '';
        }
        
        updated.brand = '';
        updated.currency = '';
        updated.acquirer = '';
      }
      
      if (field === 'acquirer') {
        // Load brands based on selected acquirer
        loadBrandsForAcquirer(value);
        // Load txn fee based on merchant and acquirer
        loadTxnFeeForMerchantAndAcquirer(updated.merchant_id, value);
        updated.brand = '';
        updated.currency = '';
      }
      
      if (field === 'brand') {
        updated.currency = '';
      }
      
      if (field === 'type' && ['Refund', 'Chargeback'].includes(value)) {
        setTxnAmountSign('-');
        const amount = Math.abs(parseFloat(updated.txn_amount) || 0);
        const fee = Math.abs(parseFloat(updated.txn_fee) || 0);
        updated.total_amount = (-amount + fee).toFixed(3);
      }
      
      if (field === 'txn_amount' || field === 'txn_fee') {
        const rawAmount = parseFloat(field === 'txn_amount' ? value : updated.txn_amount) || 0;
        const rawFee = Math.abs(parseFloat(field === 'txn_fee' ? value : updated.txn_fee) || 0);
        const type = updated.type || '';
        if (['Refund', 'Chargeback'].includes(type)) {
          updated.total_amount = (-Math.abs(rawAmount) + rawFee).toFixed(3);
        } else {
          const signMultiplier = txnAmountSign === '-' ? -1 : 1;
          const signedAmount = signMultiplier * Math.abs(rawAmount);
          updated.total_amount = (signedAmount + (signMultiplier === -1 ? rawFee : -rawFee)).toFixed(3);
        }
      }
      
      return updated;
    });
  };

  const toggleTxnAmountSign = () => {
    setTxnAmountSign(prev => prev === '+' ? '-' : '+');
    if (formData.txn_amount || formData.txn_fee) {
      const rawAmount = parseFloat(formData.txn_amount) || 0;
      const rawFee = Math.abs(parseFloat(formData.txn_fee) || 0);
      const type = formData.type || '';
      const newSign = txnAmountSign === '+' ? '-' : '+';
      const signMultiplier = newSign === '-' ? -1 : 1;
      let total;
      if (['Refund', 'Chargeback'].includes(type)) {
        total = (-Math.abs(rawAmount) + rawFee).toFixed(3);
      } else {
        const signedAmount = signMultiplier * Math.abs(rawAmount);
        total = (signedAmount + (signMultiplier === -1 ? rawFee : -rawFee)).toFixed(3);
      }
      setFormData(prev => ({ ...prev, total_amount: total }));
    }
  };

  // Detail Modal handlers
  const handleRowClick = (adjustment) => {
    setSelectedAdjustment(adjustment);
    setOpenDetailDialog(true);
  };

  const handleCloseDetailDialog = () => {
    setOpenDetailDialog(false);
    setSelectedAdjustment(null);
  };

  const getCurrentUserName = () => {
    if (currentUserName) {
      return currentUserName;
    }
  };
  
  const handleCheckAdjustment = async () => {
    if (!selectedAdjustment) return;
    
    setCheckLoading(true);
    try {
      const response = await sendDataWithPost('/payout/adjustment/check_adjustment/', {
        adjustment_id: selectedAdjustment.id
      });
      
      if (response.data.status === 'success') {
        showSuccessMsg('Adjustment checked successfully');
        handleCloseDetailDialog();
        loadAdjustments();
      } else {
        showErrorMsg(response.data.detail || 'Failed to check adjustment');
      }
    } catch (error) {
      console.error('Error checking adjustment:', error);
      const errorMsg = error.response?.data?.detail || 'Error checking adjustment';
      showErrorMsg(errorMsg);
    } finally {
      setCheckLoading(false);
    }
  };

  const handleDeleteAdjustment = async () => {
    if (!selectedAdjustment) return;
    setDeleteLoading(true);
    try {
      const response = await sendDataWithPost('/payout/adjustment/delete_adjustment/', {
        adjustment_id: selectedAdjustment.id
      });
      
      if (response.data.status === 'success') {
        showSuccessMsg('Adjustment deleted successfully');
        setOpenDeleteConfirm(false);
        handleCloseDetailDialog();
        loadAdjustments();
      } else {
        showErrorMsg(response.data.detail || 'Failed to delete adjustment');
      }
    } catch (error) {
      console.error('Error deleting adjustment:', error);
      const errorMsg = error.response?.data?.detail || 'Error deleting adjustment';
      showErrorMsg(errorMsg);
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleEditAdjustment = () => {
    if (!selectedAdjustment) return;
    const acquirerValue = selectedAdjustment.acquirer || '';
    const totalAmountValue = selectedAdjustment.total_amount || 0;
    setFormData({
      merchant_name: selectedAdjustment.merchant_id || '',
      merchant_id: selectedAdjustment.merchant_id || '',
      bank_account_no: selectedAdjustment.account_number || '',
      type: selectedAdjustment.type || '',
      brand: selectedAdjustment.brand || '',
      currency: selectedAdjustment.currency || 'SGD',
      acquirer: acquirerValue,
      txn_amount: Math.abs(selectedAdjustment.txn_amount || 0).toString(),
      txn_fee: Math.abs(selectedAdjustment.txn_fee || 0).toString(),
      total_amount: parseFloat(totalAmountValue).toFixed(3),
      details: selectedAdjustment.message || selectedAdjustment.details || ''
    });
    setTxnAmountSign(selectedAdjustment.txn_amount < 0 ? '-' : '+');
    
    if (acquirerValue && acquirerValue !== 'N/A') {
      setAcquirers([acquirerValue]);
    }
    
    if (acquirerValue && acquirerValue !== 'N/A') {
      loadBrandsForAcquirer(acquirerValue);
    }
    
    setFormSubmitted(false);
    setOpenEditDialog(true);
    
    if (merchants.length === 0) {
      loadFilterConditions();
    }
    
    if (selectedAdjustment.merchant_id) {
      loadAcquirersForMerchant(selectedAdjustment.merchant_id, selectedAdjustment.merchant_name, acquirerValue);
    }
  };

  const validateAdjustmentForm = () => {
    if (!formData.merchant_name || !formData.merchant_id || !formData.bank_account_no || 
        !formData.type || !formData.brand || !formData.currency || !formData.acquirer ||
        !formData.txn_amount || !formData.total_amount || !formData.details) {
      return false;
    }

    if (parseFloat(formData.txn_amount) === 0) {
      showErrorMsg("Transaction amount cannot be 0");
      return false;
    }

    if (parseFloat(formData.total_amount) === 0) {
      showErrorMsg("Total amount cannot be 0");
      return false;
    }

    return true;
  };

  const handleSubmitEdit = async () => {
    if (!selectedAdjustment) return;
    
    try {
      setFormSubmitted(true);
      if (!validateAdjustmentForm()) return;

      setEditLoading(true);

      const selectedMerchant = merchants.find(m => m.id === formData.merchant_name);
      const payload = {
        adjustment_id: selectedAdjustment.id,
        merchant_id: formData.merchant_id,
        merchant_name: selectedMerchant ? selectedMerchant.name : '',
        account_number: formData.bank_account_no,
        transaction_type: formData.type,
        payment_brand: formData.brand,
        currency: formData.currency,
        acquirer: formData.acquirer,
        transaction_amount: txnAmountSign === '-' ? -Math.abs(parseFloat(formData.txn_amount)) : Math.abs(parseFloat(formData.txn_amount)),
        transaction_fee: txnAmountSign === '-' ? -Math.abs(parseFloat(formData.txn_fee) || 0) : Math.abs(parseFloat(formData.txn_fee) || 0),
        total_amount: parseFloat(formData.total_amount),
        details: formData.details
      };

      const handleSuccess = (response) => {
        showSuccessMsg('Adjustment edited successfully');
        setEditLoading(false);
        setOpenEditDialog(false);
        handleCloseDetailDialog();
        loadAdjustments();
      };

      const handleError = (error) => {
        console.error('Edit adjustment error:', error);
        const errorMsg = error.response?.data?.detail || 'Failed to edit adjustment';
        showErrorMsg(errorMsg);
        setEditLoading(false);
      };

      await sendDataWithPost(
        '/payout/adjustment/edit_adjustment/',
        payload,
        null,
        null,
        handleSuccess,
        handleError
      );

    } catch (error) {
      console.error('Submit edit error:', error);
      setEditLoading(false);
    } finally {
      setEditLoading(false);
    }
  };

  const handleSubmitAdjustment = async () => {
    try {
      setFormSubmitted(true);
      if (!validateAdjustmentForm()) return;

      setCreateLoading(true);

      const selectedMerchant = merchants.find(m => m.id === formData.merchant_name);
      const payload = {
        merchant_id: formData.merchant_id,
        merchant_name: selectedMerchant ? selectedMerchant.name : '',
        account_number: formData.bank_account_no,
        transaction_type: formData.type,
        payment_brand: formData.brand,
        currency: formData.currency,
        acquirer: formData.acquirer,
        transaction_amount: txnAmountSign === '-' ? -Math.abs(parseFloat(formData.txn_amount)) : Math.abs(parseFloat(formData.txn_amount)),
        transaction_fee: txnAmountSign === '-' ? -Math.abs(parseFloat(formData.txn_fee) || 0) : Math.abs(parseFloat(formData.txn_fee) || 0),
        total_amount: parseFloat(formData.total_amount),
        details: formData.details,
        payout_status: 'Pending'
      };

      const handleSuccess = (response) => {
        showSuccessMsg('Adjustment created successfully and submitted for approval');
        setCreateLoading(false);
        handleCloseCreateDialog();
        loadAdjustments();
      };

      const handleError = (error) => {
        console.error('Create adjustment error:', error);
        setCreateLoading(false);
      };

      await sendDataWithPost(
        '/payout/adjustment/create_adjustment/',
        payload,
        null,
        null,
        handleSuccess,
        handleError
      );

    } catch (error) {
      console.error('Submit error:', error);
      setCreateLoading(false);
    } finally {
      setCreateLoading(false);
    }
  };

  const formatAmount = (amount) => {
    const value = parseFloat(amount || 0);
    return value.toFixed(3);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    if (typeof dateString === 'string' && dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return moment(dateString + ' 00:00:00').format('DD/MM/YYYY');
    }
    return moment(dateString).format('DD/MM/YYYY HH:mm:ss');
  };

  const getStatusDisplayText = (status) => {
    const statusMap = {
      'Pending': 'Pending Approval',
      'Approved': 'Pending Payout',
      'Paid': 'Settled'
    };
    return statusMap[status] || status;
  };

  const paginatedAdjustments = adjustments.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Container maxWidth="xl" sx={{ mt: 2, mb: 4 }}>
      <HeaderHelpPage title="Adjustment" isShowLink={false} />
      
      <Card sx={{ mb: 2, px: 2, py: 2, borderRadius: 2, border: '1px solid #f0f0f0' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <Box>
              <Typography sx={{ mb: 0.5, pb: 0.5, fontSize: 15, fontWeight: 500 }} variant="subtitle1">
                Status
              </Typography>
              <FormControl fullWidth>
                <Select
                  value={selectedStatus}
                  onChange={handleStatusChange}
                  size="small"
                  displayEmpty
                  sx={{
                    height: '30px',
                    '& .MuiSelect-select': {
                      fontSize: '14px',
                    }
                  }}
                >
                  <MenuItem value="all">All Status</MenuItem>
                  <MenuItem value="pending">Pending Approval</MenuItem>
                  <MenuItem value="approved">Pending Payout</MenuItem>
                  <MenuItem value="paid">Settled</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Box>
              <Typography sx={{ mb: 0.5, pb: 0.5, fontSize: 15, fontWeight: 500 }} variant="subtitle1">
                Created Timestamp
              </Typography>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  disableFuture
                  inputFormat="YYYY-MM-DD"
                  value={createDate}
                  onChange={(newValue) => setCreateDate(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      fullWidth
                      sx={{
                        '& .MuiFormLabel-root': {
                          lineHeight: '14px',
                          fontSize: '14px',
                        },
                        '& .MuiInputBase-input': {
                          fontSize: '14px',
                          height: '14px',
                        },
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Box>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Box>
              <Typography sx={{ mb: 0.5, pb: 0.5, fontSize: 15, fontWeight: 500 }} variant="subtitle1">
                Payout Date
              </Typography>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  disableFuture
                  inputFormat="YYYY-MM-DD"
                  value={payoutDate}
                  onChange={(newValue) => setPayoutDate(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      fullWidth
                      sx={{
                        '& .MuiFormLabel-root': {
                          lineHeight: '14px',
                          fontSize: '14px',
                        },
                        '& .MuiInputBase-input': {
                          fontSize: '14px',
                          height: '14px',
                        },
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Box>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', height: '100%' }}>
              {adjustmentRole.includes("Add") && (
                <LoadingButton
                  variant="contained"
                  size="small"
                  onClick={handleCreateAdjustment}
                  sx={{
                    backgroundColor: COLORS.OXYGEN7_PURPLE,
                    '&:hover': {
                      backgroundColor: 'rgba(91, 45, 130, 0.8)'
                    }
                  }}
                >
                  Create
                </LoadingButton>
              )}
            </Box>
          </Grid>
        </Grid>

        <Stack direction="row" justifyContent="flex-end">
          <ButtonCustom
            sx={{ ml: 1, mt: 2, ...styles.customButton }}
            icon={<Search />}
            variant="contained"
            title="Search"
            onClick={handleSearch}
          />
          <ButtonCustom
            sx={{ ml: 1, mt: 2 }}
            icon={<Refresh />}
            title="Reset"
            onClick={handleReset}
          />
        </Stack>
      </Card>

      {loading ? (
        <CircularLoader />
      ) : (
        <Card sx={{ borderRadius: 2, border: '1px solid #f0f0f0', position: 'relative' }}>
          {!adjustmentRole.includes("View") ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}>
              <Typography variant="body1" color="error" sx={{ fontWeight: 500 }}>
                Access Denied: You do not have permission to view adjustments
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Please contact your administrator for access
              </Typography>
            </Box>
          ) : (
            <>
              <TableContainer sx={{ overflowX: 'auto' }}>
                <Table sx={{ minWidth: 1900 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell><Typography variant="subtitle2" fontWeight={600}>Created Timestamp</Typography></TableCell>
                      <TableCell><Typography variant="subtitle2" fontWeight={600}>Merchant Name</Typography></TableCell>
                      <TableCell><Typography variant="subtitle2" fontWeight={600}>Type</Typography></TableCell>
                      <TableCell><Typography variant="subtitle2" fontWeight={600}>Brand</Typography></TableCell>
                      <TableCell><Typography variant="subtitle2" fontWeight={600}>Acquirer</Typography></TableCell>
                      <TableCell><Typography variant="subtitle2" fontWeight={600}>Currency</Typography></TableCell>
                      <TableCell align="right"><Typography variant="subtitle2" fontWeight={600}>Txn Amt</Typography></TableCell>
                      <TableCell align="right"><Typography variant="subtitle2" fontWeight={600}>Txn Fee</Typography></TableCell>
                      <TableCell align="right"><Typography variant="subtitle2" fontWeight={600}>Total Amt</Typography></TableCell>
                      <TableCell><Typography variant="subtitle2" fontWeight={600}>Status</Typography></TableCell>
                      <TableCell><Typography variant="subtitle2" fontWeight={600}>Created By</Typography></TableCell>
                      <TableCell><Typography variant="subtitle2" fontWeight={600}>Approved By</Typography></TableCell>
                      <TableCell><Typography variant="subtitle2" fontWeight={600}>Approved Timestamp</Typography></TableCell>
                      <TableCell><Typography variant="subtitle2" fontWeight={600}>Payout Date</Typography></TableCell>
                      <TableCell><Typography variant="subtitle2" fontWeight={600}>Detail</Typography></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedAdjustments.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={15} align="center" sx={{ py: 3 }}>
                          <Typography
                            gutterBottom
                            align="center"
                            variant="subtitle1"
                          >
                            Not found
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                      paginatedAdjustments.map((adjustment) => (
                      <TableRow 
                        key={adjustment.id} 
                        hover 
                        onClick={() => handleRowClick(adjustment)}
                        sx={{ cursor: 'pointer' }}
                      >
                        <TableCell>
                          <Typography variant="body2">
                            {formatDate(adjustment.created_date)}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ maxWidth: 200, wordBreak: 'break-word' }}>
                            {adjustment.merchant_name}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">{adjustment.type}</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">
                            {getBrandLabelFromMapping(adjustment.brand, adjustment.acquirer)}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">{formatAcquirer(adjustment.acquirer)}</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">{adjustment.currency}</Typography>
                        </TableCell>
                        <TableCell align="right">
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              color: adjustment.txn_amount < 0 ? '#f44336' : '#4caf50',
                              fontWeight: 500
                            }}
                          >
                            {formatAmount(adjustment.txn_amount)}
                          </Typography>
                        </TableCell>
                        <TableCell align="right">
                          <Typography variant="body2">
                            {formatAmount(adjustment.txn_fee)}
                          </Typography>
                        </TableCell>
                        <TableCell align="right">
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              color: adjustment.total_amount < 0 ? '#f44336' : '#4caf50',
                              fontWeight: 600
                            }}
                          >
                            {formatAmount(adjustment.total_amount)}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              fontWeight: 500,
                              color: adjustment.payout_status === 'Pending' ? '#ff9800' : 
                                     adjustment.payout_status === 'Approved' ? '#4caf50' : 
                                     adjustment.payout_status === 'Paid' ? '#2196f3' : '#666'
                            }}
                          >
                            {getStatusDisplayText(adjustment.payout_status || 'Pending')}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {adjustment.created_by || 'N/A'}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {adjustment.approved_by || 'N/A'}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {adjustment.approved_at ? formatDate(adjustment.approved_at) : 'N/A'}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {formatDate(adjustment.payout_date)}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <ShowDetail maxWidth={200} text={adjustment.message || adjustment.details || 'No details'} limit={50} />
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

              <TablePagination
                rowsPerPageOptions={[25, 50, 100]}
                component="div"
                count={adjustments.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </>
          )}
        </Card>
      )}

      <Dialog 
        open={openCreateDialog} 
        onClose={handleCloseCreateDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ px: 2, py: 1}}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            Create A New Adjustment
            <IconButton onClick={handleCloseCreateDialog}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Merchant Name <Typography component="span" sx={{ color: 'red', fontSize: '0.75rem' }}>*</Typography>
              </Typography>
              <Autocomplete
                options={merchants.map((merchant) => ({
                  id: merchant.id,
                  label: `${merchant.id}_${merchant.name}`,
                  name: merchant.name,
                }))}
                value={merchants.find(m => m.id === formData.merchant_name) ? {
                  id: formData.merchant_name,
                  label: `${formData.merchant_name}_${merchants.find(m => m.id === formData.merchant_name)?.name}`,
                  name: merchants.find(m => m.id === formData.merchant_name)?.name,
                } : null}
                onChange={(e, newValue) => {
                  handleFormChange('merchant_name', newValue ? newValue.id : '');
                }}
                disabled={loadingMerchants}
                loading={loadingMerchants}
                loadingText="Loading merchants..."
                noOptionsText="No merchants available"
                renderOption={(props, option) => (
                  <li {...props} key={option.id}>
                    {option.label}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder={loadingMerchants ? 'Loading merchants...' : 'Select Merchant'}
                    error={formSubmitted && !formData.merchant_name}
                    helperText={formSubmitted && !formData.merchant_name ? "Required field" : ""}
                  />
                )}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Bank Account No. <Typography component="span" sx={{ color: 'red', fontSize: '0.75rem' }}>*</Typography>
                <Typography component="span" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>(auto-populated)</Typography>
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={formData.bank_account_no}
                placeholder={formData.merchant_name ? "Auto-populated from merchant" : "Select merchant first"}
                disabled={true}
                InputProps={{ readOnly: true }}
                error={formSubmitted && !formData.bank_account_no}
                helperText={formSubmitted && !formData.bank_account_no ? "Required field" : ""}
                sx={{ 
                  '& .MuiInputBase-input.Mui-disabled': {
                    color: 'text.primary',
                    WebkitTextFillColor: 'unset'
                  },
                  '& .MuiOutlinedInput-root.Mui-disabled': {
                    backgroundColor: '#f5f5f5'
                  },
                  '& .MuiOutlinedInput-root.Mui-disabled.Mui-error .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#d32f2f !important'
                  }
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Type <Typography component="span" sx={{ color: 'red', fontSize: '0.75rem' }}>*</Typography>
              </Typography>
              <FormControl fullWidth size="small" error={formSubmitted && !formData.type}>
                <Select
                  value={formData.type}
                  error={formSubmitted && !formData.type}
                  sx={{
                    '&.Mui-disabled.Mui-error .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#d32f2f !important'
                    }
                  }}
                  onChange={(e) => handleFormChange('type', e.target.value)}
                  displayEmpty
                  IconComponent={KeyboardArrowDown}
                >
                  <MenuItem value="">
                    Select Type
                  </MenuItem>
                  <MenuItem value="Chargeback">Chargeback</MenuItem>
                  <MenuItem value="Refund">Refund</MenuItem>
                  <MenuItem value="Others">Others</MenuItem>
                </Select>
                {formSubmitted && !formData.type && <FormHelperText>Required field</FormHelperText>}
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Acquirer <Typography component="span" sx={{ color: 'red', fontSize: '0.75rem' }}>*</Typography>
              </Typography>
              <FormControl fullWidth size="small" error={formSubmitted && !formData.acquirer}>
                <Select
                  value={formData.acquirer}
                  error={formSubmitted && !formData.acquirer}
                  sx={{
                    '&.Mui-disabled.Mui-error .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#d32f2f !important'
                    }
                  }}
                  onChange={(e) => handleFormChange('acquirer', e.target.value)}
                  displayEmpty
                  IconComponent={KeyboardArrowDown}
                  disabled={loadingBrands || !formData.merchant_name}
                >
                  <MenuItem value="">
                    {loadingBrands ? 'Loading acquirers...' : 
                     !formData.merchant_name ? 'Select merchant first' : 'Select Acquirer'}
                  </MenuItem>
                  {acquirers.length === 0 ? (
                    <MenuItem disabled>No acquirers available</MenuItem>
                  ) : (
                    acquirers.map((acquirer) => (
                      <MenuItem key={acquirer} value={acquirer}>
                        {formatAcquirer(acquirer)}
                      </MenuItem>
                    ))
                  )}
                </Select>
                {formSubmitted && !formData.acquirer && <FormHelperText>Required field</FormHelperText>}
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Brand <Typography component="span" sx={{ color: 'red', fontSize: '0.75rem' }}>*</Typography>
              </Typography>
              <FormControl fullWidth size="small" error={formSubmitted && !formData.brand}>
                <Select
                  value={formData.brand}
                  error={formSubmitted && !formData.brand}
                  sx={{
                    '&.Mui-disabled.Mui-error .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#d32f2f !important'
                    }
                  }}
                  onChange={(e) => handleFormChange('brand', e.target.value)}
                  displayEmpty
                  IconComponent={KeyboardArrowDown}
                  disabled={loadingBrands || !formData.acquirer}
                >
                  <MenuItem value="">
                    {loadingBrands ? 'Loading brands...' : 
                     !formData.acquirer ? 'Select acquirer first' : 'Select Brand'}
                  </MenuItem>
                  {brands.length === 0 ? (
                    <MenuItem disabled>No brands available</MenuItem>
                  ) : (
                    brands.map((item, idx) => (
                      <MenuItem key={item.value + idx} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))
                  )}
                </Select>
                {formSubmitted && !formData.brand && <FormHelperText>Required field</FormHelperText>}
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Currency <Typography component="span" sx={{ color: 'red', fontSize: '0.75rem' }}>*</Typography>
              </Typography>
              <FormControl fullWidth size="small" error={formSubmitted && !formData.currency}>
                <Select
                  value={formData.currency}
                  error={formSubmitted && !formData.currency}
                  sx={{
                    '&.Mui-disabled.Mui-error .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#d32f2f !important'
                    }
                  }}
                  onChange={(e) => handleFormChange('currency', e.target.value)}
                  displayEmpty
                  IconComponent={KeyboardArrowDown}
                >
                  <MenuItem value="">Select Currency</MenuItem>
                  {CURRENCY_OPTIONS.map((currency) => (
                    <MenuItem key={currency} value={currency}>
                      {currency}
                    </MenuItem>
                  ))}
                </Select>
                {formSubmitted && !formData.currency && <FormHelperText>Required field</FormHelperText>}
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Txn Amt <Typography component="span" sx={{ color: 'red', fontSize: '0.75rem' }}>*</Typography>
                <Typography component="span" sx={{ fontSize: '0.75rem', color: 'text.secondary', ml: 1 }}>
                  (+/- affects both amt & fee)
                </Typography>
              </Typography>
              <TextField
                fullWidth
                size="small"
                type="number"
                value={formData.txn_amount}
                onChange={(e) => handleFormChange('txn_amount', e.target.value)}
                placeholder="100"
                error={formSubmitted && !formData.txn_amount}
                helperText={formSubmitted && !formData.txn_amount ? "Required field" : ""}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        size="small"
                        onClick={toggleTxnAmountSign}
                        disabled={formData.type === 'Refund' || formData.type === 'Chargeback'}
                        sx={{
                          color: txnAmountSign === '+' ? '#4caf50' : '#f44336',
                          fontWeight: 'bold',
                          minWidth: '24px',
                          width: '24px',
                          height: '24px',
                          fontSize: '14px',
                          '&.Mui-disabled': {
                            color: '#f44336',
                            opacity: 0.7
                          }
                        }}
                      >
                        {txnAmountSign}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Txn Fee
              </Typography>
              <TextField
                fullWidth
                size="small"
                type="number"
                value={formData.txn_fee}
                onChange={(e) => handleFormChange('txn_fee', e.target.value)}
                placeholder={loadingTxnFee ? "Loading..." : (defaultTxnFee > 0 ? `Default: ${defaultTxnFee}` : "Enter transaction fee")}
                disabled={loadingTxnFee}
                inputProps={{ min: 0, step: 0.01 }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Total Amt <Typography component="span" sx={{ color: 'red', fontSize: '0.75rem' }}>*</Typography>
                <Typography component="span" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>(auto-calculated)</Typography>
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={formData.total_amount}
                disabled
                error={formSubmitted && !formData.total_amount}
                helperText={formSubmitted && !formData.total_amount ? "Required field" : ""}
                sx={{ 
                  '& .MuiInputBase-input.Mui-disabled': {
                    color: 'text.primary',
                    WebkitTextFillColor: 'unset'
                  },
                  '& .MuiOutlinedInput-root.Mui-disabled': {
                    backgroundColor: '#f5f5f5'
                  },
                  '& .MuiOutlinedInput-root.Mui-disabled.Mui-error .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#d32f2f !important'
                  }
                }}
              />
            </Grid>


            {/* Details */}
            <Grid item xs={12}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Details <Typography component="span" sx={{ color: 'red' }}>*</Typography> <Typography component="span" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>(for merchant to see also)</Typography>
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={3}
                size="small"
                value={formData.details}
                onChange={(e) => handleFormChange('details', e.target.value)}
                placeholder="Chargeback - OrgMerchantRef: 100000123, OrgTxnDateTime: 2025-07-29 23:59:59"
                error={formSubmitted && !formData.details}
                helperText={formSubmitted && !formData.details ? "Required field" : ""}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <LoadingButton
            onClick={handleSubmitAdjustment}
            variant="contained"
            loading={createLoading}
            sx={{ 
              backgroundColor: COLORS.OXYGEN7_PURPLE,
              '&:hover': {
                backgroundColor: 'rgba(91, 45, 130, 0.8)'
              },
              mr: 1
            }}
          >
            Submit
          </LoadingButton>
        </DialogActions>
      </Dialog>

      {/* Detail Modal */}
      <Dialog
        open={openDetailDialog}
        onClose={checkLoading || editLoading ? undefined : handleCloseDetailDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" component="div">
            Adjustment Details
          </Typography>
            <IconButton 
              onClick={handleCloseDetailDialog}
              disabled={checkLoading || editLoading}
              sx={{ 
                color: 'text.secondary',
                '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' }
              }}
            >
              <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent>
          {selectedAdjustment && (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Box sx={{ 
                  border: '1px solid #000000', 
                  borderRadius: 2, 
                  p: 3
                }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" color="textSecondary">Adjustment ID:</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {selectedAdjustment.id}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" color="textSecondary">Created Date:</Typography>
                      <Typography variant="body2">
                        {formatDate(selectedAdjustment.created_date)}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" color="textSecondary">Merchant Name:</Typography>
                      <Typography variant="body2">
                        {selectedAdjustment.merchant_name}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" color="textSecondary">Bank Account No.:</Typography>
                      <Typography variant="body2">
                        {selectedAdjustment.account_number || 'N/A'}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" color="textSecondary">Transaction Type:</Typography>
                      <Typography variant="body2">
                        {selectedAdjustment.type}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" color="textSecondary">Payment Brand:</Typography>
                      <Typography variant="body2">
                        {getBrandLabelFromMapping(selectedAdjustment.brand, selectedAdjustment.acquirer)}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" color="textSecondary">Acquirer:</Typography>
                      <Typography variant="body2">
                        {formatAcquirer(selectedAdjustment.acquirer)}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" color="textSecondary">Currency:</Typography>
                      <Typography variant="body2">
                        {selectedAdjustment.currency}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" color="textSecondary">Transaction Amount:</Typography>
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          color: selectedAdjustment.txn_amount < 0 ? '#f44336' : '#4caf50',
                          fontWeight: 600
                        }}
                      >
                        {formatAmount(selectedAdjustment.txn_amount)}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" color="textSecondary">Transaction Fee:</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {formatAmount(selectedAdjustment.txn_fee)}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" color="textSecondary">Total Amount:</Typography>
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          color: selectedAdjustment.total_amount < 0 ? '#f44336' : '#4caf50',
                          fontWeight: 700,
                          fontSize: '1.1rem'
                        }}
                      >
                        {formatAmount(selectedAdjustment.total_amount)}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              {/* Right Section - Status & Activity Details */}
              <Grid item xs={12} md={6}>
                <Box sx={{ 
                  border: '1px solid #000000', 
                  borderRadius: 2, 
                  p: 3
                }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" color="textSecondary">Status:</Typography>
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          color: selectedAdjustment.payout_status === 'Pending' ? '#ff9800' : 
                                 selectedAdjustment.payout_status === 'Approved' ? '#4caf50' : 
                                 selectedAdjustment.payout_status === 'Paid' ? '#2196f3' : '#666',
                          fontWeight: 500
                        }}
                      >
                        {getStatusDisplayText(selectedAdjustment.payout_status || 'Pending')}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" color="textSecondary">Created By:</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {selectedAdjustment.created_by || 'N/A'}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" color="textSecondary">
                        Approved By:
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {selectedAdjustment.approved_by || 'N/A'}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" color="textSecondary">
                        Approved Timestamp:
                      </Typography>
                      <Typography variant="body2">
                        {selectedAdjustment.approved_at ? formatDate(selectedAdjustment.approved_at) : 'N/A'}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" color="textSecondary">Payout Date:</Typography>
                      <Typography variant="body2">
                        {selectedAdjustment.payout_date ? formatDate(selectedAdjustment.payout_date) : 'N/A'}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ mt: 2 }}>
                      <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                        Details:
                      </Typography>
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          wordBreak: 'break-word',
                          backgroundColor: '#f5f5f5',
                          padding: 2,
                          borderRadius: 1,
                          minHeight: '60px'
                        }}
                        component="div"
                      >
                        <ShowDetail text={selectedAdjustment.message || selectedAdjustment.details || 'No details provided'} limit={50} />
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        
        {selectedAdjustment && (selectedAdjustment.payout_status === 'Pending' || selectedAdjustment.payout_status === 'Approved') && (() => {
          const currentUserFullName = getCurrentUserName();
          const isRequestor = selectedAdjustment.created_by === currentUserFullName;
          const hasViewAccess = adjustmentRole.includes("View");
          const hasAddAccess = adjustmentRole.includes("Add");
          const hasEditAccess = adjustmentRole.includes("Edit");
          const canCheck = hasViewAccess || hasAddAccess || hasEditAccess;
          
          return (
            <DialogActions>
              {(selectedAdjustment.payout_status === 'Pending' || selectedAdjustment.payout_status === 'Approved') && !isRequestor && canCheck && (
                <LoadingButton
                  variant="outlined"
                  onClick={() => setOpenDeleteConfirm(true)}
                  loading={deleteLoading}
                  disabled={checkLoading || editLoading}
                  sx={{ 
                    mr: 1
                  }}
                >
                  Delete
                </LoadingButton>
              )}
              {selectedAdjustment.payout_status === 'Pending' && isRequestor ? (
                <LoadingButton
                  variant="contained"
                  onClick={handleEditAdjustment}
                  loading={editLoading}
                  disabled={checkLoading}
                  sx={{ 
                    backgroundColor: COLORS.OXYGEN7_PURPLE,
                    '&:hover': {
                      backgroundColor: 'rgba(91, 45, 130, 0.8)'
                    },
                    mr: 1
                  }}
                >
                  I want to edit
                </LoadingButton>
              ) : selectedAdjustment.payout_status === 'Pending' && canCheck ? (
                <LoadingButton
                  variant="contained"
                  onClick={handleCheckAdjustment}
                  loading={checkLoading}
                  disabled={editLoading}
                  sx={{ 
                    backgroundColor: COLORS.OXYGEN7_PURPLE,
                    '&:hover': {
                      backgroundColor: 'rgba(91, 45, 130, 0.8)'
                    },
                    mr: 1
                  }}
                >
                  I have checked
                </LoadingButton>
              ) : null}
            </DialogActions>
          );
        })()}
      </Dialog>

      {/* Edit Dialog - Reuse Create Dialog structure */}
      <Dialog 
        open={openEditDialog} 
        onClose={editLoading ? undefined : () => {
          setOpenEditDialog(false);
          setFormSubmitted(false);
          setFormData({
            merchant_name: '',
            merchant_id: '',
            bank_account_no: '',
            type: '',
            brand: '',
            currency: '',
            acquirer: '',
            txn_amount: '',
            txn_fee: '',
            total_amount: '',
            details: ''
          });
          setTxnAmountSign('+');
          setBrands([]);
          setAcquirers([]);
          setDefaultTxnFee(0);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ px: 2, py: 1}}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            Edit Adjustment
            <IconButton onClick={() => {
              setOpenEditDialog(false);
              setFormSubmitted(false);
              setFormData({
                merchant_name: '',
                merchant_id: '',
                bank_account_no: '',
                type: '',
                brand: '',
                currency: '',
                acquirer: '',
                txn_amount: '',
                txn_fee: '',
                total_amount: '',
                details: ''
              });
              setTxnAmountSign('+');
              setBrands([]);
              setAcquirers([]);
              setDefaultTxnFee(0);
            }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Merchant Name <Typography component="span" sx={{ color: 'red', fontSize: '0.75rem' }}>*</Typography>
              </Typography>
              <Autocomplete
                options={merchants.map((merchant) => ({
                  id: merchant.id,
                  label: `${merchant.id}_${merchant.name}`,
                  name: merchant.name,
                }))}
                value={merchants.find(m => m.id === formData.merchant_name) ? {
                  id: formData.merchant_name,
                  label: `${formData.merchant_name}_${merchants.find(m => m.id === formData.merchant_name)?.name}`,
                  name: merchants.find(m => m.id === formData.merchant_name)?.name,
                } : null}
                onChange={(e, newValue) => {
                  handleFormChange('merchant_name', newValue ? newValue.id : '');
                }}
                disabled={loadingMerchants || editLoading}
                loading={loadingMerchants}
                loadingText="Loading merchants..."
                noOptionsText="No merchants available"
                renderOption={(props, option) => (
                  <li {...props} key={option.id}>
                    {option.label}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder={loadingMerchants ? 'Loading merchants...' : 'Select Merchant'}
                    error={formSubmitted && !formData.merchant_name}
                    helperText={formSubmitted && !formData.merchant_name ? "Required field" : ""}
                  />
                )}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Bank Account No. <Typography component="span" sx={{ color: 'red', fontSize: '0.75rem' }}>*</Typography>
                <Typography component="span" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>(auto-populated)</Typography>
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={formData.bank_account_no}
                placeholder={formData.merchant_name ? "Auto-populated from merchant" : "Select merchant first"}
                disabled={true}
                InputProps={{ readOnly: true }}
                error={formSubmitted && !formData.bank_account_no}
                helperText={formSubmitted && !formData.bank_account_no ? "Required field" : ""}
                sx={{ 
                  '& .MuiInputBase-input.Mui-disabled': {
                    color: 'text.primary',
                    WebkitTextFillColor: 'unset'
                  },
                  '& .MuiOutlinedInput-root.Mui-disabled': {
                    backgroundColor: '#f5f5f5'
                  },
                  '& .MuiOutlinedInput-root.Mui-disabled.Mui-error .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#d32f2f !important'
                  }
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Type <Typography component="span" sx={{ color: 'red', fontSize: '0.75rem' }}>*</Typography>
              </Typography>
              <FormControl fullWidth size="small" error={formSubmitted && !formData.type}>
                <Select
                  value={formData.type}
                  error={formSubmitted && !formData.type}
                  sx={{
                    '&.Mui-disabled.Mui-error .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#d32f2f !important'
                    }
                  }}
                  onChange={(e) => handleFormChange('type', e.target.value)}
                  displayEmpty
                  IconComponent={KeyboardArrowDown}
                  disabled={editLoading}
                >
                  <MenuItem value="">
                    Select Type
                  </MenuItem>
                  <MenuItem value="Chargeback">Chargeback</MenuItem>
                  <MenuItem value="Refund">Refund</MenuItem>
                  <MenuItem value="Others">Others</MenuItem>
                </Select>
                {formSubmitted && !formData.type && <FormHelperText>Required field</FormHelperText>}
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Acquirer <Typography component="span" sx={{ color: 'red', fontSize: '0.75rem' }}>*</Typography>
              </Typography>
              <FormControl fullWidth size="small" error={formSubmitted && !formData.acquirer}>
                <Select
                  value={formData.acquirer}
                  error={formSubmitted && !formData.acquirer}
                  sx={{
                    '&.Mui-disabled.Mui-error .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#d32f2f !important'
                    }
                  }}
                  onChange={(e) => handleFormChange('acquirer', e.target.value)}
                  displayEmpty
                  IconComponent={KeyboardArrowDown}
                  disabled={(!formData.acquirer && loadingBrands) || !formData.merchant_name || editLoading}
                >
                  <MenuItem value="">
                    {(!formData.acquirer && loadingBrands) ? 'Loading acquirers...' : 
                     !formData.merchant_name ? 'Select merchant first' : 'Select Acquirer'}
                  </MenuItem>
                  {acquirers.length === 0 ? (
                    <MenuItem disabled>No acquirers available</MenuItem>
                  ) : (
                    acquirers.map((acquirer) => (
                      <MenuItem key={acquirer} value={acquirer}>
                        {formatAcquirer(acquirer)}
                      </MenuItem>
                    ))
                  )}
                </Select>
                {formSubmitted && !formData.acquirer && <FormHelperText>Required field</FormHelperText>}
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Brand <Typography component="span" sx={{ color: 'red', fontSize: '0.75rem' }}>*</Typography>
              </Typography>
              <FormControl fullWidth size="small" error={formSubmitted && !formData.brand}>
                <Select
                  value={formData.brand}
                  error={formSubmitted && !formData.brand}
                  sx={{
                    '&.Mui-disabled.Mui-error .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#d32f2f !important'
                    }
                  }}
                  onChange={(e) => handleFormChange('brand', e.target.value)}
                  displayEmpty
                  IconComponent={KeyboardArrowDown}
                  disabled={(!formData.brand && loadingBrands) || !formData.acquirer || editLoading}
                >
                  <MenuItem value="">
                    {(!formData.brand && loadingBrands) ? 'Loading brands...' : 
                     !formData.acquirer ? 'Select acquirer first' : 'Select Brand'}
                  </MenuItem>
                  {brands.length === 0 ? (
                    <MenuItem disabled>No brands available</MenuItem>
                  ) : (
                    brands.map((item, idx) => (
                      <MenuItem key={item.value + idx} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))
                  )}
                </Select>
                {formSubmitted && !formData.brand && <FormHelperText>Required field</FormHelperText>}
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Currency <Typography component="span" sx={{ color: 'red', fontSize: '0.75rem' }}>*</Typography>
              </Typography>
              <FormControl fullWidth size="small" error={formSubmitted && !formData.currency}>
                <Select
                  value={formData.currency}
                  error={formSubmitted && !formData.currency}
                  sx={{
                    '&.Mui-disabled.Mui-error .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#d32f2f !important'
                    }
                  }}
                  onChange={(e) => handleFormChange('currency', e.target.value)}
                  displayEmpty
                  IconComponent={KeyboardArrowDown}
                  disabled={editLoading}
                >
                  <MenuItem value="">Select Currency</MenuItem>
                  {CURRENCY_OPTIONS.map((currency) => (
                    <MenuItem key={currency} value={currency}>
                      {currency}
                    </MenuItem>
                  ))}
                </Select>
                {formSubmitted && !formData.currency && <FormHelperText>Required field</FormHelperText>}
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Txn Amt <Typography component="span" sx={{ color: 'red', fontSize: '0.75rem' }}>*</Typography>
                <Typography component="span" sx={{ fontSize: '0.75rem', color: 'text.secondary', ml: 1 }}>
                  (+/- affects both amt & fee)
                </Typography>
              </Typography>
              <TextField
                fullWidth
                size="small"
                type="number"
                value={formData.txn_amount}
                onChange={(e) => handleFormChange('txn_amount', e.target.value)}
                placeholder="100"
                error={formSubmitted && !formData.txn_amount}
                helperText={formSubmitted && !formData.txn_amount ? "Required field" : ""}
                disabled={editLoading}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        size="small"
                        onClick={toggleTxnAmountSign}
                        disabled={formData.type === 'Refund' || formData.type === 'Chargeback' || editLoading}
                        sx={{
                          color: txnAmountSign === '+' ? '#4caf50' : '#f44336',
                          fontWeight: 'bold',
                          minWidth: '24px',
                          width: '24px',
                          height: '24px',
                          fontSize: '14px',
                          '&.Mui-disabled': {
                            color: '#f44336',
                            opacity: 0.7
                          }
                        }}
                      >
                        {txnAmountSign}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Txn Fee
              </Typography>
              <TextField
                fullWidth
                size="small"
                type="number"
                value={formData.txn_fee}
                onChange={(e) => handleFormChange('txn_fee', e.target.value)}
                placeholder={loadingTxnFee ? "Loading..." : (defaultTxnFee > 0 ? `Default: ${defaultTxnFee}` : "Enter transaction fee")}
                disabled={(!formData.txn_fee && loadingTxnFee) || editLoading}
                inputProps={{ min: 0, step: 0.01 }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Total Amt <Typography component="span" sx={{ color: 'red', fontSize: '0.75rem' }}>*</Typography>
                <Typography component="span" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>(auto-calculated)</Typography>
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={formData.total_amount}
                disabled
                error={formSubmitted && !formData.total_amount}
                helperText={formSubmitted && !formData.total_amount ? "Required field" : ""}
                sx={{ 
                  '& .MuiInputBase-input.Mui-disabled': {
                    color: 'text.primary',
                    WebkitTextFillColor: 'unset'
                  },
                  '& .MuiOutlinedInput-root.Mui-disabled': {
                    backgroundColor: '#f5f5f5'
                  },
                  '& .MuiOutlinedInput-root.Mui-disabled.Mui-error .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#d32f2f !important'
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Details <Typography component="span" sx={{ color: 'red' }}>*</Typography> <Typography component="span" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>(for merchant to see also)</Typography>
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={3}
                size="small"
                value={formData.details}
                onChange={(e) => handleFormChange('details', e.target.value)}
                placeholder="Chargeback - OrgMerchantRef: 100000123, OrgTxnDateTime: 2025-07-29 23:59:59"
                error={formSubmitted && !formData.details}
                helperText={formSubmitted && !formData.details ? "Required field" : ""}
                disabled={editLoading}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <LoadingButton
            onClick={handleSubmitEdit}
            variant="contained"
            loading={editLoading}
            sx={{ 
              backgroundColor: COLORS.OXYGEN7_PURPLE,
              '&:hover': {
                backgroundColor: 'rgba(91, 45, 130, 0.8)'
              },
              mr: 1
            }}
          >
            Save Changes
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openDeleteConfirm} onClose={() => !deleteLoading && setOpenDeleteConfirm(false)}>
        <DialogTitle>Are you sure you want to delete this adjustment record?</DialogTitle>
        <DialogActions sx={{ px: 2, py: 1 }}>
          <Button variant="outlined" onClick={() => setOpenDeleteConfirm(false)} disabled={deleteLoading}>
            Cancel
          </Button>
          <LoadingButton
            variant="contained"
            color="error"
            onClick={handleDeleteAdjustment}
            loading={deleteLoading}
            sx={{ ...styles.customButton }}
          >
            Delete
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default Adjustment;
